/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  CreateFilterDTO,
  CreateFilterDTOFromJSON,
  CreateFilterDTOToJSON,
  FilterListResponseDTO,
  FilterListResponseDTOFromJSON,
  FilterListResponseDTOToJSON,
  FilterResponseDTO,
  FilterResponseDTOFromJSON,
  FilterResponseDTOToJSON,
  OutFilterDTO,
  OutFilterDTOFromJSON,
  OutFilterDTOToJSON,
  PutFilterDTO,
  PutFilterDTOFromJSON,
  PutFilterDTOToJSON
} from "../models";

export interface DeleteFilterRequest {
  filterId: number;
}

export interface FindAllByRequest {
  typeIds: string;
  take: number;
  searchQuery: string;
  platformId?: number;
  filters?: string;
  merchantFilters?: string;
  promotion?: string;
}

export interface FindAllMerchantTopFiltersRequest {
  platformId: number;
  take: number;
  filters?: string;
}

export interface FindAllTopFiltersByTypeRequest {
  platformId: number;
  typeId: number;
  take: number;
  promotion: string;
  filters?: string;
  merchantFilters?: string;
}

export interface FindMerchantFiltersByRequest {
  take: number;
  searchQuery?: string;
  platformId?: number;
  filters?: string;
}

export interface GetAllFiltersRequest {
  take: number;
  skip: number;
  typeIds?: string;
  searchQuery?: string;
  exactSearch?: string;
}

export interface GetFilterRequest {
  filterId: number;
}

export interface PostFilterRequest {
  createFilterDTO: CreateFilterDTO;
}

export interface PutFilterRequest {
  filterId: number;
  putFilterDTO: PutFilterDTO;
}

/**
 *
 */
export class FiltersApi extends runtime.BaseAPI {
  /**
   */
  async deleteFilterRaw(
    requestParameters: DeleteFilterRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters.filterId === null || requestParameters.filterId === undefined) {
      throw new runtime.RequiredError(
        "filterId",
        "Required parameter requestParameters.filterId was null or undefined when calling deleteFilter."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/filters/{filterId}`.replace(
          `{${"filterId"}}`,
          encodeURIComponent(String(requestParameters.filterId))
        ),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.TextApiResponse(response) as any;
  }

  /**
   */
  async deleteFilter(requestParameters: DeleteFilterRequest, initOverrides?: RequestInit): Promise<boolean> {
    const response = await this.deleteFilterRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async findAllByRaw(
    requestParameters: FindAllByRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<FilterResponseDTO>> {
    if (requestParameters.typeIds === null || requestParameters.typeIds === undefined) {
      throw new runtime.RequiredError(
        "typeIds",
        "Required parameter requestParameters.typeIds was null or undefined when calling findAllBy."
      );
    }

    if (requestParameters.take === null || requestParameters.take === undefined) {
      throw new runtime.RequiredError(
        "take",
        "Required parameter requestParameters.take was null or undefined when calling findAllBy."
      );
    }

    if (requestParameters.searchQuery === null || requestParameters.searchQuery === undefined) {
      throw new runtime.RequiredError(
        "searchQuery",
        "Required parameter requestParameters.searchQuery was null or undefined when calling findAllBy."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.typeIds !== undefined) {
      queryParameters["typeIds"] = requestParameters.typeIds;
    }

    if (requestParameters.take !== undefined) {
      queryParameters["take"] = requestParameters.take;
    }

    if (requestParameters.searchQuery !== undefined) {
      queryParameters["searchQuery"] = requestParameters.searchQuery;
    }

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    if (requestParameters.filters !== undefined) {
      queryParameters["filters"] = requestParameters.filters;
    }

    if (requestParameters.merchantFilters !== undefined) {
      queryParameters["merchantFilters"] = requestParameters.merchantFilters;
    }

    if (requestParameters.promotion !== undefined) {
      queryParameters["promotion"] = requestParameters.promotion;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/filters`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, jsonValue => FilterResponseDTOFromJSON(jsonValue));
  }

  /**
   */
  async findAllBy(requestParameters: FindAllByRequest, initOverrides?: RequestInit): Promise<FilterResponseDTO> {
    const response = await this.findAllByRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async findAllMerchantTopFiltersRaw(
    requestParameters: FindAllMerchantTopFiltersRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<Array<OutFilterDTO>>> {
    if (requestParameters.platformId === null || requestParameters.platformId === undefined) {
      throw new runtime.RequiredError(
        "platformId",
        "Required parameter requestParameters.platformId was null or undefined when calling findAllMerchantTopFilters."
      );
    }

    if (requestParameters.take === null || requestParameters.take === undefined) {
      throw new runtime.RequiredError(
        "take",
        "Required parameter requestParameters.take was null or undefined when calling findAllMerchantTopFilters."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    if (requestParameters.filters !== undefined) {
      queryParameters["filters"] = requestParameters.filters;
    }

    if (requestParameters.take !== undefined) {
      queryParameters["take"] = requestParameters.take;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/filters/merchants/top`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, jsonValue => jsonValue.map(OutFilterDTOFromJSON));
  }

  /**
   */
  async findAllMerchantTopFilters(
    requestParameters: FindAllMerchantTopFiltersRequest,
    initOverrides?: RequestInit
  ): Promise<Array<OutFilterDTO>> {
    const response = await this.findAllMerchantTopFiltersRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async findAllTopFiltersByTypeRaw(
    requestParameters: FindAllTopFiltersByTypeRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<Array<OutFilterDTO>>> {
    if (requestParameters.platformId === null || requestParameters.platformId === undefined) {
      throw new runtime.RequiredError(
        "platformId",
        "Required parameter requestParameters.platformId was null or undefined when calling findAllTopFiltersByType."
      );
    }

    if (requestParameters.typeId === null || requestParameters.typeId === undefined) {
      throw new runtime.RequiredError(
        "typeId",
        "Required parameter requestParameters.typeId was null or undefined when calling findAllTopFiltersByType."
      );
    }

    if (requestParameters.take === null || requestParameters.take === undefined) {
      throw new runtime.RequiredError(
        "take",
        "Required parameter requestParameters.take was null or undefined when calling findAllTopFiltersByType."
      );
    }

    if (requestParameters.promotion === null || requestParameters.promotion === undefined) {
      throw new runtime.RequiredError(
        "promotion",
        "Required parameter requestParameters.promotion was null or undefined when calling findAllTopFiltersByType."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    if (requestParameters.filters !== undefined) {
      queryParameters["filters"] = requestParameters.filters;
    }

    if (requestParameters.typeId !== undefined) {
      queryParameters["typeId"] = requestParameters.typeId;
    }

    if (requestParameters.take !== undefined) {
      queryParameters["take"] = requestParameters.take;
    }

    if (requestParameters.promotion !== undefined) {
      queryParameters["promotion"] = requestParameters.promotion;
    }

    if (requestParameters.merchantFilters !== undefined) {
      queryParameters["merchantFilters"] = requestParameters.merchantFilters;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/filters/top`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, jsonValue => jsonValue.map(OutFilterDTOFromJSON));
  }

  /**
   */
  async findAllTopFiltersByType(
    requestParameters: FindAllTopFiltersByTypeRequest,
    initOverrides?: RequestInit
  ): Promise<Array<OutFilterDTO>> {
    const response = await this.findAllTopFiltersByTypeRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async findMerchantFiltersByRaw(
    requestParameters: FindMerchantFiltersByRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<FilterResponseDTO>> {
    if (requestParameters.take === null || requestParameters.take === undefined) {
      throw new runtime.RequiredError(
        "take",
        "Required parameter requestParameters.take was null or undefined when calling findMerchantFiltersBy."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.take !== undefined) {
      queryParameters["take"] = requestParameters.take;
    }

    if (requestParameters.searchQuery !== undefined) {
      queryParameters["searchQuery"] = requestParameters.searchQuery;
    }

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    if (requestParameters.filters !== undefined) {
      queryParameters["filters"] = requestParameters.filters;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/filters/merchants`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, jsonValue => FilterResponseDTOFromJSON(jsonValue));
  }

  /**
   */
  async findMerchantFiltersBy(
    requestParameters: FindMerchantFiltersByRequest,
    initOverrides?: RequestInit
  ): Promise<FilterResponseDTO> {
    const response = await this.findMerchantFiltersByRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async getAllFiltersRaw(
    requestParameters: GetAllFiltersRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<FilterListResponseDTO>> {
    if (requestParameters.take === null || requestParameters.take === undefined) {
      throw new runtime.RequiredError(
        "take",
        "Required parameter requestParameters.take was null or undefined when calling getAllFilters."
      );
    }

    if (requestParameters.skip === null || requestParameters.skip === undefined) {
      throw new runtime.RequiredError(
        "skip",
        "Required parameter requestParameters.skip was null or undefined when calling getAllFilters."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.take !== undefined) {
      queryParameters["take"] = requestParameters.take;
    }

    if (requestParameters.skip !== undefined) {
      queryParameters["skip"] = requestParameters.skip;
    }

    if (requestParameters.typeIds !== undefined) {
      queryParameters["typeIds"] = requestParameters.typeIds;
    }

    if (requestParameters.searchQuery !== undefined) {
      queryParameters["searchQuery"] = requestParameters.searchQuery;
    }

    if (requestParameters.exactSearch !== undefined) {
      queryParameters["exactSearch"] = requestParameters.exactSearch;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/filters/extended`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, jsonValue => FilterListResponseDTOFromJSON(jsonValue));
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async getAllFilters(
    requestParameters: GetAllFiltersRequest,
    initOverrides?: RequestInit
  ): Promise<FilterListResponseDTO> {
    const response = await this.getAllFiltersRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getFilterRaw(
    requestParameters: GetFilterRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<OutFilterDTO>> {
    if (requestParameters.filterId === null || requestParameters.filterId === undefined) {
      throw new runtime.RequiredError(
        "filterId",
        "Required parameter requestParameters.filterId was null or undefined when calling getFilter."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/filters/{filterId}`.replace(
          `{${"filterId"}}`,
          encodeURIComponent(String(requestParameters.filterId))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, jsonValue => OutFilterDTOFromJSON(jsonValue));
  }

  /**
   */
  async getFilter(requestParameters: GetFilterRequest, initOverrides?: RequestInit): Promise<OutFilterDTO> {
    const response = await this.getFilterRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async postFilterRaw(
    requestParameters: PostFilterRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<OutFilterDTO>> {
    if (requestParameters.createFilterDTO === null || requestParameters.createFilterDTO === undefined) {
      throw new runtime.RequiredError(
        "createFilterDTO",
        "Required parameter requestParameters.createFilterDTO was null or undefined when calling postFilter."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/filters`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateFilterDTOToJSON(requestParameters.createFilterDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, jsonValue => OutFilterDTOFromJSON(jsonValue));
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async postFilter(requestParameters: PostFilterRequest, initOverrides?: RequestInit): Promise<OutFilterDTO> {
    const response = await this.postFilterRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async putFilterRaw(
    requestParameters: PutFilterRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<OutFilterDTO>> {
    if (requestParameters.filterId === null || requestParameters.filterId === undefined) {
      throw new runtime.RequiredError(
        "filterId",
        "Required parameter requestParameters.filterId was null or undefined when calling putFilter."
      );
    }

    if (requestParameters.putFilterDTO === null || requestParameters.putFilterDTO === undefined) {
      throw new runtime.RequiredError(
        "putFilterDTO",
        "Required parameter requestParameters.putFilterDTO was null or undefined when calling putFilter."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/filters/{filterId}`.replace(
          `{${"filterId"}}`,
          encodeURIComponent(String(requestParameters.filterId))
        ),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: PutFilterDTOToJSON(requestParameters.putFilterDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, jsonValue => OutFilterDTOFromJSON(jsonValue));
  }

  /**
   */
  async putFilter(requestParameters: PutFilterRequest, initOverrides?: RequestInit): Promise<OutFilterDTO> {
    const response = await this.putFilterRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
